<template>
  <Tab
    v-slot="{ selected }"
    class="group shrink-0 w-5/12 sm:flex-1 cursor-pointer text-gray-700 hover:text-gray-200 group relative bg-gray-100 py-4 px-4 text-sm font-semibold text-center hover:bg-blue-600 focus:z-10"
  >
    <span v-if="!isFlagged">
      {{ label }}
    </span>
    <span v-else>
      <span class="flex items-center justify-center gap-1">
        <span
          v-if="showIndicatorCount"
          class="text-xs bg-red-400 group-hover:bg-gray-100 group-hover:text-gray-700 text-gray-100 rounded-full w-5 h-5 flex items-center justify-center"
        >
          {{ indicatorCount }}
        </span>

        <FlagIcon
          :size="FLAG_ICON_SIZE"
          class="text-red-400 shrink-0 group-hover:text-gray-100"
        />
        {{ label }}
      </span>
    </span>
    <span
      aria-hidden="true"
      :class="[
        selected ? 'bg-blue-600 group-hover:bg-gray-200' : 'bg-transparent',
        'rounded-tl rounded-tr absolute inset-x-5 md:inset-x-10 bottom-0 h-1'
      ]"
    />
  </Tab>
</template>

<script setup>
import { inject } from 'vue'
import { Tab } from '@headlessui/vue'
import { kebabCase } from 'lodash'
import { PAGE_TABS_COMPONENT } from '@/utils/symbols'
import { FlagIcon, FLAG_ICON_SIZE } from '@/Components/Flags'

const props = defineProps({
  label: {
    type: String,
    required: true
  },
  tabKey: {
    type: [String, null],
    required: false,
    default: null
  },
  isFlagged: {
    type: Boolean,
    required: false,
    default: false
  },
  indicatorCount: {
    type: Number,
    required: false,
    default: 0
  },
  showIndicatorCount: {
    type: Boolean,
    required: false,
    default: false
  }
})

const pageTabs = inject(PAGE_TABS_COMPONENT)

if (!pageTabs) {
  throw new Error('PageTab must be used with a PageTabGroup parent.')
}

pageTabs.registerTab({
  key: encodeURIComponent(props.tabKey ?? kebabCase(props.label))
})
</script>
